// src/domains/listview.ts —— U-22 E-04 次级列表加载态（资产明细 / 本卡交易 / 提币记录 / 佣金明细 / 通知）：
// 每页 20；首屏 3 行骨架；has_more 显示「加载更多」；has_more=false 且总数 > 20 显示「没有更多了」；
// 首屏失败 = 空态 + 「重试」；加载更多失败 toast errNetwork、按钮保留可再次点击
import type { CursorList } from '../../../shared/src/page';

export const LIST_PAGE_SIZE = 20;

export interface ListFlags {
  skel: boolean; // 首屏在途：3 行骨架
  empty: boolean; // 首屏完成且无行（含首屏失败）：I18N.empty 空态
  retry: boolean; // 首屏失败：空态下方「重试」
  more: boolean; // 「加载更多」（加载更多失败后保留）
  noMore: boolean; // 「没有更多了」
}

const NONE: ListFlags = { skel: false, empty: false, retry: false, more: false, noMore: false };

type ListLike = Pick<CursorList<unknown>, 'items' | 'page' | 'hasMore' | 'firstLoading' | 'error'>;

export function listFlags(l: ListLike | null, pageSize: number = LIST_PAGE_SIZE): ListFlags {
  if (!l) return NONE;
  if (l.firstLoading) return { ...NONE, skel: true };
  const n = l.items.length;
  const firstFailed = l.error && l.page === 0;
  return {
    skel: false,
    empty: n === 0,
    retry: firstFailed,
    more: !firstFailed && l.hasMore && n > 0,
    noMore: !l.hasMore && n > pageSize,
  };
}
